import Vue from 'vue'

// BugSnag
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

if(process.env.BUGTRACKER && process.client) {
  let releaseStage = null
  switch(process.env.GW_ENV) {
    case 'dev':
      releaseStage = 'development'
      break
    case 'stage':
      releaseStage = 'staging'
      break
    default:
      releaseStage = 'production'
  }
  const bugsnagConfig = {
    apiKey: process.env.BUGTRACKER,
    plugins: [new BugsnagPluginVue()],
    appVersion: process.env.APP_VERSION,
    releaseStage
  }
  Bugsnag.start(bugsnagConfig)

  const bugsnagVue = Bugsnag.getPlugin('vue')
  Vue.use(bugsnagVue)
}

// GTM
import VueGtm from 'vue-tag-manager'

if(process.env.GTM_ID && process.client) {
  Vue.use(VueGtm, {
    gtmId: process.env.GTM_ID
  })
}

// VueMask
import VueMask from 'v-mask'
Vue.use(VueMask)

// Transitions
import Transitions from 'vue2-transitions'
Vue.use(Transitions)

// Facebook Signin
if (process.env.FACEBOOK_CLIENT_ID && process.client) {
  const vue_fb = {}
  vue_fb.install = function install(Vue, options) {
    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {return}
      js = d.createElement(s)
      js.id = id
      js.src = "//connect.facebook.net/en_US/sdk.js"
      fjs.parentNode.insertBefore(js, fjs)
      console.log('setting fb sdk')
    }(document, 'script', 'facebook-jssdk'))
  
    window.fbAsyncInit = function onSDKInit() {
      FB.init(options)
      FB.AppEvents.logPageView()
      Vue.FB = FB
      window.dispatchEvent(new Event('fb-sdk-ready'))
    }
    Vue.FB = undefined
  }

  Vue.use(vue_fb, {
    appId: process.env.FACEBOOK_CLIENT_ID,
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v2.9'
  })
}
